/* eslint-disable frontApplet/enforce-jsdoc */
import AppletError from './AppletError';
import { IBaseSosErrorParams } from './SosError';

export interface IAppletStreamErrorParams extends IBaseSosErrorParams {
	kind: 'appletStreamError';
}

export default class AppletStreamError extends AppletError {
	constructor(parameters: IAppletStreamErrorParams) {
		super({
			...parameters,
			kind: 'appletError',
			type: parameters.type ? parameters.type : 'AppletStreamError',
		});
	}
}
